import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgZincGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.454 10.026 17.096 10l-.203.295-8.689 12.646-.204.297.155.325 6.592 13.85.155.326.36.028 15.281 1.204.36.029.204-.298 8.69-12.645.203-.296-.153-.325-6.592-13.95-.156-.33-.364-.026-15.281-1.104ZM9.439 23.35l8.282-12.053 14.56 1.052 6.282 13.295-8.282 12.052-14.56-1.148-6.282-13.198Zm10.297-3.97 3.798 2.514-.553.843-4.754 1.818 2.589 1.714-.632.964-3.917-2.594.553-.843 4.776-1.803-2.491-1.65.631-.963Zm7.826-2.192.798-.768.867.9-.746.718.737.68-.849.918-.79-.73-.749.722-.867-.9.697-.671-.788-.728.849-.918.84.777Zm0 14.652.798-.768.867.9-.746.718.737.681-.849.918-.79-.73-.749.721-.867-.9.697-.671-.788-.728.849-.918.84.777Zm0-7.326.798-.768.867.9-.746.718.737.68-.849.919-.79-.73-.749.721-.867-.9.697-.671-.788-.728.849-.918.84.777Z",
    fill: "currentColor"
  }));
}

export { SvgZincGlyph as default };
